import BaseStore from 'hljd/esm/SearchBar/store'
import Api from '@api/groupMember'
import { getMerchantInfo, getPropertyId, isSiDaTeam } from '@util'
import { Modal } from 'hljd'
import InviteModalStore from './InviteModal/store'
import { dGet } from '@core/utils'

class Store extends BaseStore {
  $listApi = Api.groupMemberList
  $noNeed = ['name']
  $pageSizeKey = 'perPage'

  constructor() {
    super()
    this.inviteModalStore = new InviteModalStore()
  }

  $getParams = () => {
    const { field, order } = this.$sorter || {}
    return {
      ...this.$params,
      fullEdition: isSiDaTeam() ? 1 : 0,
      propertyId: getPropertyId(),
      groupId: isSiDaTeam()
        ? getMerchantInfo().id
        : dGet(getMerchantInfo(), 'group.id'),
      needScheduleCount: 1,
      sortColumn: field,
      sortType: order ? (order === 'descend' ? 'desc' : 'asc') : ''
    }
  }

  /**
   * 团队移除成员
   */
  removeFromTeam = (merchantId, tempId) => {
    Modal.confirm({
      title: '你确定要将此成员移出团队吗？',
      onOk: () => {
        return new Promise(async (resolve, reject) => {
          const { success } = await Api.deleteMember({
            merchantId,
            tempId: merchantId == 0 ? tempId : null
          })

          if (success) {
            resolve()
            this.$getList()
          } else {
            reject()
          }
        })
      }
    })
  }

  /**
   * 三大团队设置成员是否显示
   */
  setMemberShow = async (data, merchantId) => {
    const { success } = await Api.setMemberShow({
      isMemberShow: data ? 1 : 0,
      merchantId
    })
    if (success) {
      this.$getList()
    }
  }
}

export default Store
